import styled, { css } from 'styled-components';

import { basicBodyTextStyle, basicSmallTextStyle, basicTransition, focusStyle } from '@dreryk/react-components';

export const StyledNewsCardListElement = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   gap: 2px;
   height: 36px;
   border-bottom: 1px solid ${(props) => props.theme.borderLight};
`;

StyledNewsCardListElement.displayName = 'StyledNewsCardListElement';

export const StyledNewsCardListElementLink = styled.a`
   ${basicBodyTextStyle}
   ${basicTransition}
   ${focusStyle}
   text-decoration: none;
   cursor: pointer;
   user-select: none;
   width: fit-content;
   max-width: 100%;
   font-weight: 700;

   ${({ theme }) => css`
      color: ${theme.primary};
      fill: ${theme.primary};

      &:focus-visible {
         box-shadow: 0 0 0 2px ${theme.primaryLighter};
      }

      &:hover {
         color: ${theme.primaryDark};
         fill: ${theme.primaryDark};
      }
   `}

   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`;

StyledNewsCardListElementLink.displayName = 'StyledNewsCardListElementLink';

export const StyledNewsCardListElementDateAndTag = styled.div`
   ${basicSmallTextStyle}
   color: ${(props) => props.theme.border};
   margin-bottom: 2px;
`;

StyledNewsCardListElementDateAndTag.displayName = 'StyledNewsCardListElementDateAndTag';
